import { Form } from "antd";
import React from "react";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import {EmailFormItemProps} from "../../model/common/email-form-item-props";


const EmailFormItem: React.FC<EmailFormItemProps> = ({label, name, children, rules, isFieldChanged}) => {
    // const [form] = Form.useForm(); // 或用 useContext 取得表單實例
    const form = useFormInstance();
    const errors = form.getFieldError(name);
    const modified = isFieldChanged && isFieldChanged(name);
    return (
        <Form.Item
            label={label}
            name={name}
            rules={rules}
            validateTrigger="onChange"
            validateStatus={
                errors.length > 0 ? 'error' : modified ? 'warning' : ''
            }
            help={
                errors.length > 0
                    ? errors[0]
                    : modified
                        ? '此欄位已修改'
                        : ''
            }
        >
            {children}
        </Form.Item>
    );
};

export default EmailFormItem;